<!--<div class="pagebrk"></div>
  <printheaderview>
  </printheaderview>-->

  <div class="row">
    <div class="col-print-12 padding-left-0px">
      <div class="card background-color-wt">
        <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

          <div class="row">
            <div class="col-print-12 text-align-center">
              <label class="font-familyhead">Services List</label>
            </div>
          </div>

          <!--<div class="row bordertop border-bot-1px margin-left-0px margin-right-0px margin-bottom-10px" *ngFor="let p of CurrentPatientInfoByFormattedCodeController">
    <div class="col-print-5 margin-top-10 margin-bottom-10px">
      <div class="row margin-left-0px margin-right-0px">
        <div class="col-print-6">
          <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
        </div>
        <div class="col-print-6">
          <label class="margin-bottom-0px font-family float-left font-weight-bold">{{p.DisplayName}}</label>
        </div>
      </div>
      <div class="row margin-left-0px margin-right-0px">
        <div class="col-print-6">
          <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
        </div>
        <div class="col-print-6">
          <label class="margin-bottom-0px font-family float-left font-weight-normal">{{p.Gender}}/{{p.Age}}</label>
        </div>
      </div>

    </div>

    <div class="col-print-1"></div>

    <div class="col-print-5 margin-top-10 margin-bottom-10px">
      <div class="row margin-left-0px margin-right-0px">
        <div class="col-print-6">
          <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
        </div>
        <div class="col-print-6">
          <label class="margin-bottom-0px font-family float-left font-weight-normal">{{p.FormattedCode}}</label>
        </div>
      </div>
      <div class="row margin-left-0px margin-right-0px">
        <div class="col-print-6">
          <label class="margin-bottom-0px font-family font-weight-normal">Mobile No:</label>
        </div>
        <div class="col-print-6">
          <label class="margin-bottom-0px font-family float-left font-weight-normal">{{p.Telephone1}}</label>
        </div>
      </div>

    </div>
  </div>-->

          <div class="row margin-left-0px bordertop margin-right-0px" *ngFor="let l of BillCodes">
            <!--<div class="col-print-2">
      <label class="margin-bottom-0px font-family font-weight-bold">Bill Code :</label>
    </div>-->
            <div class="col-print-8">
              <label class="margin-bottom-0px font-family font-weight-bold">{{l.BillCode}} ({{l.BillDate | date:'MMM-dd-yyyy'}})</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family font-weight-bold">[{{l.BranchName}}]</label>
            </div>
            <div class="col-print-12">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-12">
                  <div class="table-component margin-bottom-0px">
                    <div class="table-responsive">
                      <table class="table table-striped margin-left-zero border4">
                        <tr>

                          <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                            #
                          </th>

                          <!--<th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                    Date
                  </th>-->
                          <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                            Service Description
                          </th>
                          <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                            Item Total
                          </th>
                          <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                            QTY
                          </th>

                          <!--<th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                    Branch
                  </th>-->

                        </tr>
                        <tr *ngFor="let d of GetItems(l.BillCode);let RowIndex = index">
                          <td class="font-family padding-top-2px padding-bottom-2px">{{RowIndex+1}}</td>
                          <!--<td class="font-family padding-top-2px padding-bottom-2px">{{d.BillDate | date:'MMM-dd-yyyy'}}</td>-->
                          <td class="font-family padding-top-2px padding-bottom-2px">{{d.ItemDescription}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px">{{d.ItemValue}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px">
                            {{d.Quantity}}
                          </td>
                          <!--<td class="font-family padding-top-2px padding-bottom-2px">{{d.BranchName}}</td>-->
                        </tr>

                      </table>

                    </div>
                  </div>
                </div>
              </div>

              <div class="row margin-top-5px margin-bottom-5px margin-left-0px margin-right-0px">
                <div class="col-print-12 text-align-right">
                  <label class="font-weight-normal font-family margin-bottom-0px text-align-right">Total Value: {{l.NetBillValue}}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="row bordertop border-bot-1px">
            <div class="col-print-12 text-align-center">
              <label class="margin-bottom-10px font-familyhead">Refund List</label>
            </div>
          </div>

          <div class="row margin-left-0px margin-right-0px margin-top-10 margin-bottom-10px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero border4">
                    <tr>

                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                        #
                      </th>

                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                        Date
                      </th>
                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                        Service Description
                      </th>
                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                        Item Total
                      </th>
                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                        Refund Total
                      </th>

                    </tr>
                    <tr *ngFor="let s of RefundData;let RowIndex = index">
                      <td class="font-family padding-top-2px padding-bottom-2px">{{RowIndex+1}}</td>
                      <td class="font-family padding-top-2px padding-bottom-2px">{{s.RefundPaidDate | date:'MMM-dd-yyyy'}}</td>
                      <td class="font-family padding-top-2px padding-bottom-2px">{{s.ItemDescription}}</td>
                      <td class="font-family padding-top-2px padding-bottom-2px">{{s.ItemTotal| number:'1.0-0'}}</td>
                      <td class="font-family padding-top-2px padding-bottom-2px">
                        {{s.RefundTotal| number:'1.0-0'}}
                      </td>
                    </tr>

                  </table>

                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>

<!--<printfooterview></printfooterview>-->
